/*
 * Whether an axios response from the API reports success.
 *
 * The panel API answers { success: true, message, data } (responseFormatter).
 * Older endpoints answered { status: '200', ... } or { status: 'success', ... },
 * and many pages still check only one of those — against the current shape
 * that is always false, so a save that worked was reported as failed (or
 * silently ignored). Accept all three shapes.
 */
export const isApiSuccess = (res) => {
  const body = res?.data;
  if (body?.success === true) return true;
  const status = String(body?.status);
  return status === '200' || status === 'success';
};

export default isApiSuccess;
